import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

// ******* FOR USER ******* (GET ALL ADDRESSES)
const getAddresses = async () => {
  try {
    const token = getAuthToken();
    const response = await api.get("/addresses", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

// ADD ADDRESS
const addAddress = async (address) => {
  try {
    const token = getAuthToken();
    const response = await api.post("/addresses/add", address, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

// DELETE ADDRESS
const deleteAddress = async (addressId) => {
  try {
    const token = getAuthToken();
    const response = await api.delete(`/addresses/${addressId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

// SET DEFAULT ADDRESS
const setDefaultAddress = async (addressId) => {
  const token = getAuthToken();
  const response = await api.put(
    `/addresses/${addressId}`,
    {
      isDefault: true,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

// UPDATE ADDRESS
const updateAddress = async (addressId, address) => {
  const token = getAuthToken();
  const response = await api.put(`/addresses/${addressId}`, address, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export {
  getAddresses,
  addAddress,
  deleteAddress,
  updateAddress,
  setDefaultAddress,
  // getUserDefaultAddress,
  // getAddressById,
};
